import { createFileRoute } from "@tanstack/react-router";
import Partners from "@/pages/Partners";
import { routeHead } from "@/lib/seo/route-head";
import { platformStatsQueryOptions } from '@/hooks/usePlatformStats';

export const Route = createFileRoute("/parteneri/")({
  head: () => routeHead("/parteneri/"),
  loader: ({ context }) => context.queryClient.ensureQueryData(platformStatsQueryOptions()).catch(() => undefined),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Partners />
  );
}
